<template>
  <div class="centerx">
    <vs-popup
      classContent="popup-example"
      :title="$t('tickets.label.edit.header')"
      :active.sync="ticketPopupEdit"
      class="popup-close"
    >
      <ValidationObserver ref="observer">
        <form ref="form">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('tickets.label.edit.Ticket Number')"
              >
                <vs-input
                  :label="$t('tickets.label.edit.Ticket Number')"
                  class="w-full font-semibold starlabel"
                  readonly
                  v-model="ticket.ticketNumber"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("tickets.label.edit.Status")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('tickets.label.edit.Status')"
                >
                  <v-select
                    label="mCodeValue"
                    :options="ticketData.statusType"
                    :placeholder="$t('entity.label.SelectCategory')"
                    :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.status"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("tickets.label.edit.Category")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('tickets.label.edit.Category')"
                >
                  <v-select
                    label="mCodeValue"
                    :options="ticketTemplates.problemsDatas"
                    :placeholder="$t('entity.label.SelectCategory')"
                    :reduce="(mCodeValue) => mCodeValue.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.problemCode"
                    @input="getSubCategory()"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("tickets.label.edit.Sub Category")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('tickets.label.edit.Sub Category')"
                >
                  <v-select
                    label="subCategory"
                    :options="subCategoryItem"
                    :placeholder="$t('entity.label.SelectSubCategory')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.subCategory"
                    :reduce="(subCategory) => subCategory.subCategory"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("tickets.label.edit.Assign To")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('tickets.label.edit.Assign To')"
                >
                  <v-select
                    label="userName"
                    :options="ticketTemplates.usersData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.assignedTo"
                    :reduce="(userName) => userName.id"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('tickets.label.edit.Title')"
              >
                <vs-input
                  :label="$t('tickets.label.edit.Title')"
                  v-model="ticket.title"
                  class="w-full font-semibold mb-2 starlabel"
                  icon-no-border
                  :danger="false"
                  danger-text="wrong input"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("tickets.label.edit.Comment")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.description')"
                >
                  <vs-textarea
                    class="w-full"
                    v-model="ticket.description"
                    hint="Please provide as much detail as possible so we can best assist you."
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <pick-file @fileUpdate="changeFile" />
            </div>
          </div>

          <div style="height: 30px"></div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="updateTicket"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("entity.label.submit") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </ValidationObserver>
      <validation-popup
        :errorMessage="errorMessage"
        :warningPopup="warningPopup"
        :warningText="warningText"
        @closeWarning="warningPopup = false"
      ></validation-popup>
    </vs-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { setHeader, removeHeader } from "@/http";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import PickFile from "@/components/PickFile.vue";
import vSelect from "vue-select";

const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  ticketNumber: null,
  title: "",
  type: "Office",
  status: "",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: null,
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null,
};
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
    entityId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      ticket: { ...ticketObj },
      bulkUploads: {
        file: null,
      },
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
    PickFile,
  },
  computed: {
    tickets() {
      return this.$store.getters["entity/getEntityTickets"];
    },
    ...mapState({
      ticketCreated: (state) => state.entity.createTicketResponse,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      ticketData: (state) => state.entity.editTicketTemplate,
    }),

    ticketTemplates() {
      return this.$store.getters["entity/getTicketTemplate"];
    },
    ticketPopupEdit: {
      get() {
        if (this.active) this.ticketTemplate();
        return this.active;
      },
      set(newval) {
        if (!newval) {
          this.$emit("closePopup");
        }
      },
    },
  },
  methods: {
    changeDocument() {
      this.bulkUploads.file = document.getElementById("file").files[0];
    },
    async getSubCategory() {
      try {
        this.$store.dispatch(
          "entity/setTicketSubcategory",
          this.ticket.problemCode
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async ticketTemplate() {
      try {
        this.$store.dispatch("entity/setTicketTemplate");
        await this.$store.dispatch("entity/getEditTicketData", {
          entityId: this.entityId,
          ticketId: this.id,
        });
        this.ticket.ticketNumber = this.ticketData.ticketNumber;
        this.ticket.status = this.ticketData.status;
        this.ticket.priority = this.ticketData.priority;
        this.ticket.problemCode = this.ticketData.problemCode;
        this.getSubCategory();
        this.ticket.title = this.ticketData.title;
        this.ticket.description = this.ticketData.lastComment;
        this.ticket.subCategory = this.ticketData.subCategoryStatus;

        for (let temp of this.ticketData.usersData) {
          if (temp.userName === this.ticketData.userName)
            this.ticket.assignedTo = temp.id;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateTicket() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.ticketPopupEdit = false;
      try {
        let payload = {
          assignedTo: this.ticket.assignedTo,
          comments: this.ticket.description,
          ticketNumber: this.ticket.ticketNumber,
          status: this.ticket.status,
          title: this.ticket.title,
          priority: this.ticket.priority,
          problemCode: this.ticket.problemCode,
          subCategory: this.ticket.subCategory,
          locale: "en",
          ticketURL: `${this.ticket.ticketURL2}${this.entityId}`,
        };
        let formData = new FormData();
        setHeader("Content-Type", "multipart/form-data");
        formData.append("name", this.ticket.title);
        formData.append("description", this.ticket.description);
        formData.append("file", this.bulkUploads.file);

        removeHeader("Content-Type");

        await this.$store.dispatch("entity/updateTicketAction", {
          id: this.id,
          data: payload,
        });

        formData.append("childEntityId", this.ticketCreated);
        this.$store.dispatch("entity/createTicketDocAction", {
          id: this.entityId,
          data: formData,
        });

        this.ticket = { ...ticketObj };
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    changeFile(file) {
      this.bulkUploads.file = file;
    },
  },
  watch: {},
  mounted() {},
};
</script>
